import styled from '@emotion/styled';
import { Card } from 'antd';

export const LoanCard = styled(Card)`
  box-shadow: 0 2px 8px #00000017;
  width: 100%;
`;

export const Description = styled.p`
  color: ${props => props.theme.color.text};
  margin-bottom: ${props => props.theme.spacing.xxs};
`;

export const Logo = styled.div`
  background-color: ${props => props.theme.color.secondary};
  border-radius: 50%;
  color: ${props => props.theme.color.primary};
  font-size: 24px;
  line-height: 48px;
  text-align: center;
  height: 48px;
  width: 48px;
`;

export const Title = styled.p`
  color: ${props => props.theme.color.primary};
  font-size: 24px;
  font-weight: ${props => props.theme.fontWeight.bold};
  margin-bottom: ${props => props.theme.spacing.xxs};
`;

export const ProtectedStatus = styled.div`
  background-color: ${props => (props.isProtected ? props.theme.color.green : props.theme.color.red)};
  border-radius: 50%;
  margin-right: ${props => props.theme.spacing.xxs};
  margin-bottom: ${props => props.theme.spacing.xxs};
  width: 14px;
  height: 14px;
`;
